export { default } from './AppGenerica';
